// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"79ea15a0","2741":"79ea15a0","4961":"79ea15a0"}[chunkId] + ".chunk.css";
};